import React from "react"
import classnames from "classnames"
import styles from "./DealerSearch.less"
import { H6, P, A, AddressIcon, HoursIcon, WebsiteIcon, PhoneIcon, InfoIcon } from "AtomicComponents"

const Icon = ({ name }) => {
  const style = {
    fill: '#999999',
    marginRight: '8px',
    padding: '3px 0',
    flexShrink: 0,
    height: '20px',
    width: '20px'
  }

  switch (name) {
    case "hours":
      return <HoursIcon style={style} />
    case "address":
      return <AddressIcon style={style} />
    case "website":
      return <WebsiteIcon style={style} />
    case "phone":
      return <PhoneIcon style={style} />
    case "info":
      return <InfoIcon style={style} />
  }
}

const DealerDetails = ({ dealer, department }) => (
  <div className={classnames({
    [styles.Dealer]: true
  })}>
    <H6 withDetails>{dealer.name}</H6>
    <ul className={classnames({
      [styles.DealerDetails]: true
    })}>
      <li>
        <Icon name="address" />
        <P withoutMargin>
          <A
            external
            styleName="blue"
            href={`https://google.com.au/maps?q=${dealer.address}+${dealer.suburb}+${dealer.state}+${dealer.postCode}/`}>
            {dealer.address}, {dealer.suburb}, {dealer.state} {dealer.postCode}
          </A>
        </P>
      </li>
      <li>
        <Icon name="hours" />
        <div>
          <strong>Opening hours:</strong>
          {department.hours.map((label, index) => <P withoutMargin key={index}>{label}</P>)}
        </div>
      </li>
      <li>
        <Icon name="website" />
        <P withoutMargin>
          <A
            external
            styleName="blue"
            href={dealer.website}>
            {dealer.websiteLabel}
          </A>
        </P>
      </li>
      <li>
        <Icon name="phone" />
        <P withoutMargin>{department.phoneLabel}</P>
      </li>
    </ul>
  </div>
)

export default DealerDetails



// WEBPACK FOOTER //
// ./src/AtomicContainers/DealerSearch/DealerDetails.jsx